import { NavigationService } from 'src/services/navigation-service';
import { OrderStep } from 'src/state/order/types';

interface Step {
  step: OrderStep;
  path: string;
  order: number;
}

const ORDER_STEPS: Record<OrderStep, Step> = {
  [OrderStep.CHOOSE_ACCOUNT]: {
    step: OrderStep.CHOOSE_ACCOUNT,
    path: NavigationService.CHOOSE_ACCOUNT,
    order: 1,
  },
  [OrderStep.CHOOSE_SERVICE_LOCATION]: {
    step: OrderStep.CHOOSE_SERVICE_LOCATION,
    path: NavigationService.CHOOSE_SERVICE_LOCATION,
    order: 2,
  },
  [OrderStep.PRODUCT_SELECT]: {
    step: OrderStep.PRODUCT_SELECT,
    path: NavigationService.PRODUCT_SELECT,
    order: 4,
  },
  [OrderStep.PURCHASE_DECODER]: {
    step: OrderStep.PURCHASE_DECODER,
    path: NavigationService.PRODUCT_PURCHASE,
    order: 5,
  },
  [OrderStep.UPGRADE_DECODER]: {
    step: OrderStep.UPGRADE_DECODER,
    path: NavigationService.PRODUCT_UPGRADE,
    order: 5,
  },
  [OrderStep.SUMMARY]: {
    step: OrderStep.SUMMARY,
    path: NavigationService.SUMMARY,
    order: 6,
  },
  [OrderStep.SUCCESS]: {
    step: OrderStep.SUCCESS,
    path: NavigationService.SUCCESS,
    order: 7,
  },
};

const isBefore = (step: OrderStep, reachedStep: OrderStep): boolean =>
  ORDER_STEPS[step].order <= ORDER_STEPS[reachedStep].order;

const getStepPath = (step: OrderStep): string => ORDER_STEPS[step].path;

export const OrderStepService = {
  isBefore,
  getStepPath,
};
